import React from "react";
import { WelcomeAutocomplete, WelcomeSimulate, WelcomeCheck } from "../Icons";

/**
 * Render the intro text.
 */
interface IntroProps {
  /** Class applied to the root wrapper. */
  className?: string;
}

const Intro = ({ className }: IntroProps) => {
  return (
    <div className={className}>
      <h1 className="mt-5 mb-5 w-full text-[60px] font-medium tracking-[-4px]">
        Welcome to Merlin
      </h1>
      <h2 className="mt-0 mb-[100px] w-full text-left text-[38px] font-light tracking-[-2.53px]">
        The tool for Modelling Enterprises INtelligently
      </h2>
      <p className="mt-0 mb-4 w-full text-[16px] font-light leading-[27px]">
        <strong>MERLIN</strong> enables you to create object-oriented domain
        models in an intelligent way. More than just a UML drawing tool, MERLIN helps you create high-quality models by:

      </p>
      <div className="selling-points mb-[15px] w-full pl-5 text-[16px] font-light leading-[27px] text-[#f8fafb]">
        <div className="selling-point mb-2.5 flex min-h-9 flex-row items-center last:mb-0">
          <div className="icon mr-5 h-6 [&_svg]:h-6">
            <WelcomeAutocomplete />
          </div>
          <div className="text">
            Automatically completing the models by applying{" "}
            <strong>the MERODE modelling guidelines</strong>
          </div>
        </div>
        <div className="selling-point mb-2.5 flex min-h-9 flex-row items-center last:mb-0">
          <div className="icon mr-5 h-6 [&_svg]:h-6">
            <WelcomeCheck />
          </div>
          <div className="text">
            Checking models for <strong>internal consistency</strong>
          </div>
        </div>
        <div className="selling-point mb-2.5 flex min-h-9 flex-row items-center last:mb-0">
          <div className="icon mr-5 h-6 [&_svg]:h-6">
            <WelcomeSimulate />
          </div>
          <div className="text">
            Simulating models using the <strong>Java code generator</strong>
          </div>
        </div>
      </div>
      <p className="mt-0 mb-4 w-full text-[16px] font-light leading-[27px]">
        Find out more at{" "}
        <a
          href="http://merode.econ.kuleuven.be/"
          className="border-b border-dotted border-[#f8fafb] text-[#f8fafb] no-underline hover:border-solid"
        >
          merode.econ.kuleuven.be
        </a>
        .
      </p>
      <p className="mt-0 mb-4 w-full text-[16px] font-light leading-[27px]">
        Have fun modelling!
      </p>
    </div>
  );
};

export default Intro;
